function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredef1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredef1"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("8VVoY", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("JSq6p")).then(()=>parcelRequire("50i7i"));

});

var $baa0d15c0af437e2$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"aT88m":"index.b94be7b3.js","JSq6p":"webfontloader.e2b5b9a4.js"}'));

/**
 * Generic backgroundImage class
 */ class $cbffd09070f7415f$export$3d0b85b7d4419b92 {
    constructor(game, type, speed, differntStartPos, version){
        this.destroyed = false;
        this.scale = 1;
        this.paused = false;
        this.differntStartPos = differntStartPos;
        this.positionX = this.getLeftOrRightStartPos();
        this.positionY = this.generaterandomYPos();
        this.speed = speed;
        this.intervalId = null;
        this.game = game;
        this.onclick = null;
        this.el = null;
        this.leftToRight;
        this.type = type;
        this.version = version;
    }
    getLeftOrRightStartPos() {
        var startPos = 0;
        if (this.differntStartPos) {
            var canvasWidth = document.getElementById("canvas").offsetWidth;
            startPos = Math.floor(Math.random() * canvasWidth);
        } else {
            var canvasWidth = document.getElementById("canvas").offsetWidth;
            var rand = Math.floor(Math.random() * Math.floor(2));
            switch(rand){
                case 0:
                    startPos = -(150 * this.scale);
                    this.leftToRight = true;
                    break;
                case 1:
                    startPos = canvasWidth + 150 * this.scale;
                    this.leftToRight = false;
                    break;
            }
        }
        return startPos;
    }
    generaterandomYPos() {
        var canvasHeight = document.getElementById("canvas").offsetHeight;
        canvasHeight = canvasHeight - 200;
        return Math.floor(Math.random() * canvasHeight);
    }
    updateIamgePosition() {
        if (this.game.isPaused) return;
        var destroyed = false;
        var left = parseFloat(this.el.style.left);
        if (this.leftToRight) {
            this.el.style.left = left + this.speed + "px";
            if (left > this.game.screenWidth + 100 * this.scale) {
                this.destroy();
                destroyed = true;
            }
        } else {
            this.el.style.left = left - this.speed + "px";
            if (left < -100 * this.scale) {
                this.destroy();
                destroyed = true;
            }
        }
        if (!destroyed) this.intervalId = requestAnimationFrame(this.updateIamgePosition.bind(this));
    }
    /**
     * Spawn the image as an element on the screen.
     *
     */ spawnOnCanvas() {
        this.el = document.createElement("div");
        if (this.type === "cloud") this.el.className = this.type + " type" + Math.round(Math.random() * 2 + 1);
        else this.el.className = this.type;
        this.game.gameLog("create", this.el.className);
        this.el.style.left = this.positionX + "px";
        this.el.style.bottom = this.positionY + "px";
        let scale = 1;
        let opacity = 1;
        switch(this.el.className){
            case "bird":
                scale = this.game.config.birdScale;
                break;
            case "plane":
                scale = this.game.config.planeScale;
                break;
            case "cloud type1":
                scale = this.game.config.cloud1Scale;
                opacity = this.game.config.cloud1Opacity;
                break;
            case "cloud type2":
                scale = this.game.config.cloud2Scale;
                opacity = this.game.config.cloud2Opacity;
                break;
            case "cloud type3":
                scale = this.game.config.cloud3Scale;
                opacity = this.game.config.cloud3Opacity;
                break;
        }
        this.scale = scale;
        let direction = this.leftToRight ? 1 : -1;
        this.el.style.transform = "scaleX(" + direction * scale + ")" + " scaleY(" + scale + ")";
        this.el.style.opacity = opacity;
        // this.el.addEventListener("touchstart", (event) => {
        //     event.preventDefault();
        //     event.stopImmediatePropagation();
        //     return;
        // }, false);
        this.sound?.play();
        this.game.canvasElement.appendChild(this.el);
        if (!this.leftToRight) this.el.className += " rtl";
        requestAnimationFrame(this.updateIamgePosition.bind(this));
    }
    /**
     * Destroys the element.
     */ destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.game.gameLog(this.el.className + " destroyed!");
        cancelAnimationFrame(this.intervalId);
        this.game.canvasElement.removeChild(this.el);
        var directSpawn = false;
        if (this.type.indexOf("cloud") > -1) {
            this.type = "cloud";
            directSpawn = true;
        }
    // this.game.imageSpawner(this.type, 1, directSpawn, false);
    }
    pause(state) {
        this.paused = state;
        if (!this.paused) requestAnimationFrame(this.updateIamgePosition.bind(this));
    }
}


function $22f5f922ddc3e706$export$9c04d8fd885bb013(element, action, touchAction) {
    if ("ontouchstart" in window) {
        console.log("tochstart available");
        if (touchAction) element.addEventListener("touchstart", touchAction, {
            passive: false
        });
        else element.addEventListener("touchstart", action, {
            passive: false
        });
    } else {
        console.log("no tochstart");
        element.addEventListener("mousedown", action, {
            passive: false
        });
    }
}
function $22f5f922ddc3e706$export$9a23bd5abbd0d648() {
    // Register gesturestart to prevent complex events
    document.addEventListener("gesturestart", (e)=>{
        e.preventDefault();
        $22f5f922ddc3e706$var$registerEvent("gesturestart");
    }, {
        passive: false
    });
    // Handle default mouse down OR touch start to prevent pinch zoom etc.
    $22f5f922ddc3e706$export$9c04d8fd885bb013(document, (e)=>{
        $22f5f922ddc3e706$var$registerEvent("prevent " + e.type);
        e.preventDefault();
    });
    // Catch move events
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) window.document.addEventListener("touchmove", (e)=>{
        $22f5f922ddc3e706$var$registerEvent("ios touch move");
        e.preventDefault();
    }, {
        passive: false
    });
}
function $22f5f922ddc3e706$var$registerEvent(name) {
    if (document.getElementById("messages")) document.getElementById("messages").innerHTML = name + "<br>" + document.getElementById("messages").innerHTML;
// if (top.document.getElementById('messages')) {
//   top.document.getElementById('messages').innerHTML = name + '<br>' + top.document.getElementById('messages').innerHTML;
// }
}


class $3fb20517fc32462b$export$3016537a1ffc38d5 {
    constructor(game, color, setting){
        this.type = "normal";
        this.el = null;
        this.balloonId = null;
        this.explosion = null;
        this.explosionTimout = null;
        this.health = 0;
        this.paused = false;
        this.game = game;
        this.positionX = this.generateRandomXPos();
        this.color = color;
        this.positionY = this.game.screenHeight;
        this.health = setting.health;
        this.setting = game.config.balloonSettings[color];
        this.speed = (Math.random() * (setting.maxSpeed - setting.minSpeed) + setting.minSpeed) * this.game.balloonSpeedMultiplier * (this.game.screenHeight / 570);
        this.type = "normal";
        this.el = null;
        this.balloonId = null;
        this.explosion = null;
        this.explosionTimout = null;
        this.state = "init";
    }
    /**
	 * allows the speed of the baloom to be multiplied
	 * @param {int} multiplier
	 */ setMultipliedSpeed(multiplier) {
        this.speed *= multiplier;
    }
    updateBalloonPosition() {
        if (this.state !== "active") return;
        if (this.game.isPaused) return;
        this.positionY -= this.speed;
        this.el.style.top = this.positionY + "px";
        if (parseInt(this.el.style.top) < -this.el.clientHeight / 2 * (this.game.screenHeight / 570)) {
            this.destroy();
            this.game.removeLife();
        } else this.intervalId = requestAnimationFrame(this.updateBalloonPosition.bind(this));
    }
    /**
	 * Make sure the balloon spawns on a random X position
	 */ generateRandomXPos() {
        var canvasWidth = document.getElementById("canvas").offsetWidth;
        canvasWidth = canvasWidth - 106;
        return Math.floor(Math.random() * canvasWidth);
    }
    hit() {
        this.game.playSound("hit");
        this.health--;
        if (this.health > 0) {
            if (this.game.config.scoreType === "points" || this.game.config.scoreType === "timeandpoints") {
                this.game.score += this.setting.hitScore;
                this.game.updateScore(this.game.score, true);
            }
            return;
        }
        if (this.setting.next !== "none") {
            this.color = "balloon" + this.setting.next;
            if (this.game.config.scoreType === "points" || this.game.config.scoreType === "timeandpoints") {
                this.game.score += this.setting.popScore;
                this.game.updateScore(this.game.score, true);
            }
            this.setting = this.game.config.balloonSettings[this.color];
        } else this.fullHit();
        this.el.className = "balloon " + this.color;
    }
    fullHit() {
        if (this.game.config.scoreType === "points" || this.game.config.scoreType === "timeandpoints") {
            this.game.score += this.setting.popScore;
            this.game.updateScore(this.game.score, true);
        }
        if (this.state === "removed") return;
        this.state = "removed";
        this.explode();
    }
    /**
	 * Spawn the balloon as an element on the screen.
	 *
	 * @param {int} multiplier
	 */ spawnOnCanvas(multiplier, balloonId) {
        this.balloonId = balloonId;
        this.el = document.createElement("div");
        this.el.className = "balloon " + this.color;
        this.el.id = balloonId;
        this.el.style.left = this.positionX + "px";
        this.el.style.top = this.positionY + "px";
        this.el.style.transform = "scale(" + this.game.config.balloonScale + ")";
        var balloon = this;
        if (this.game.debug) {
            const debug = document.createElement("div");
            debug.className = "debug";
            debug.innerHTML = `speed: ${this.speed}\nhealth: ${this.health}`;
            this.el.appendChild(debug);
        }
        // Handle mouse down OR touch start
        (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(this.el, (event)=>{
            event.preventDefault();
            event.stopImmediatePropagation();
            balloon.hit();
        });
        this.game.canvasElement.appendChild(this.el);
        this.state = "active";
        // this.setMultipliedSpeed(multiplier);
        // if(this.game.debug){
        //     this.el.className += ' debug';
        // }
        requestAnimationFrame(this.updateBalloonPosition.bind(this));
    }
    /**
	 * Destroys the element.
	 */ destroy() {
        if (this.state === "removed") return;
        this.state = "removed";
        this.game.numberOfBalloons--;
        this.game.canvasElement.removeChild(this.el);
    }
    explode() {
        this.game.playSound("explode");
        this.game.numberOfBalloons--;
        setTimeout(()=>{
            if (this.el === null) return;
            const el = this.el;
            el.className = "balloon";
            if (this.game.debug) {
                const debug = el.firstElementChild;
                el.removeChild(debug);
            }
            const explosion = this.el;
            let left = parseInt(explosion.style.left);
            let bottom = parseInt(explosion.style.top);
            explosion.style.left = left + this.game.config.explosionOffsetX * this.game.config.explosionScale + "px";
            explosion.style.top = bottom + this.game.config.explosionOffsetY * this.game.config.explosionScale + "px";
            explosion.className = "balloon explosion";
            explosion.style.opacity = this.game.config.explosionOpacity;
            explosion.style.transform = "scale(" + this.game.config.balloonScale * this.game.config.explosionScale + ")";
        }, 2);
        setTimeout(()=>{
            this.game.canvasElement.removeChild(this.el);
        }, this.game.config.explosionDuration + 2);
    }
    pause(state) {
        this.paused = state;
        if (!this.paused) requestAnimationFrame(this.updateBalloonPosition.bind(this));
    }
}



// Message to the platform

class $c39ed129cd641cb9$export$2dffd0b5373a4389 {
    constructor(){
        this.game = undefined;
        this.scoreFreeze = false;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    receive(data) {
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            case "play":
                this.game.play(); // Send play message to the game
                break;
            case "restart":
                this.game.restart();
        }
    }
    init(game, config, callback) {
        this.game = game;
        // Load fonts and then send ready event
        let fonts = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = "" + v;
            if (key.includes("Font") && !fonts.includes(value) && !$c39ed129cd641cb9$var$excludedFonts.includes(value)) fonts.push(value);
        }
        if (fonts.length > 0) (parcelRequire("8VVoY")).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                    this.ready();
                    callback();
                }
            });
        });
        else {
            this.ready();
            callback();
        }
    }
    /**
	 * Retrieve play event when game actualy starts
	 */ gamestarted() {
        // console.log('G: SEND', 'play');
        this.sendEvent({
            eventName: "start"
        });
    }
    play() {
        this.game?.play();
    }
    /**
	 * Retrieve gameover event from game whith endsoce
	 */ gameover(score) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: Math.floor(score)
            }
        });
    }
    /**
	 * Receive ready event from game when allowed to use start
	 */ ready() {
        this.sendEvent({
            eventName: "ready"
        });
    }
    playSound(sound) {
        this.sendEvent({
            eventName: "sound",
            data: sound
        });
    }
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    /**
	 * Send message to the game platform
	 * @param event
	 */ sendEvent(event) {
        window?.parent?.postMessage(event, "*");
    }
    sendScore(score, showAnim) {
        console.log(showAnim);
        if (showAnim) {
            this.sendEvent({
                eventName: "score",
                data: {
                    score: Math.floor(score)
                }
            });
            return;
        }
        this.sendEvent({
            eventName: "score",
            data: Math.floor(score)
        });
    }
    sendLives(lives) {
        if (lives >= 0) this.sendEvent({
            eventName: "lives",
            data: lives
        });
    }
}
const $c39ed129cd641cb9$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


const $7b066675d1aa79fa$var$DefaultConfig = {
    balloonTypes: 4,
    startSpeed: 1,
    levelUpMethod: "time",
    speedIncrease: 0.02,
    levelUpInterval: 100,
    balloon1Sprite: "red.png",
    balloon2Sprite: "green.png",
    balloon3Sprite: "pink.png",
    balloon4Sprite: "orange.png",
    cloud1Sprite: "cloud1.png",
    cloud2Sprite: "cloud2.png",
    cloud3Sprite: "cloud3.png",
    planeSprite: "plane.png",
    birdSprite: "bird.png",
    explosionSprite: "explode.png",
    explosionDuration: 250,
    explosionOffsetX: 0,
    explosionOffsetY: 0,
    lifeSprite: "life.png",
    lifeLostSprite: "life-lost.png",
    lifeScale: 0.5,
    startSpawnTime: 1200,
    minimumSpawnTime: 200,
    spawnIncrease: 10,
    minNumberOfBalloons: 1,
    maxNumberOfBalloons: 8,
    balloonIncrease: 1,
    //minspeed,maxspeed,hitscore,health,changescore,next,popscore
    balloon1: "2,3,10,3,3,none ",
    balloon3: "3,3,1,5,0,green",
    balloon2: "4,5,20,1,3,none",
    balloon4: "5,5,30,1,3,none",
    balloonScale: 2,
    explosionScale: 2,
    cloud1Scale: 2,
    birdScale: 3,
    planeScale: 0.5,
    bonusPerMs: 0.01,
    path: "https://gamecdn.playenwin.com/wietse/balloon/default/",
    lives: 3,
    overlayColor: "#FFFFFF",
    pauseMessage: "Spel gepauzeerd",
    scoreFont: "Bungee",
    scoreColor: "#000000",
    scoreSize: 30,
    pauseMessageColor: "#000000",
    pauseMessageFont: "Arial",
    pauseMessageSize: 50,
    birdSpawnTimeMax: 500,
    birdSpawnTimeMin: 500,
    planeSpawnTimeMax: 3000,
    planeSpawnTimeMin: 3000,
    cloudSpawnTimeMin: 1000,
    cloudSpawnTimeMax: 1500,
    scoreType: "timeandpoints"
};
class $7b066675d1aa79fa$export$35806d2c657a1231 {
    constructor(){
        this.images = [];
        this.imageLoadCount = 0;
        this.balloons = [];
        this.timer = 0;
        this.bgElements = [];
        // printConfig(DefaultConfig);
        this.debug = false; // turn true if you wan to log
        this.isPaused = false;
        this.balloonId = null;
        this.score = null;
        this.playElement = document.getElementById("start-btn");
        this.scoreElement = document.getElementById("score-label");
        this.livesElement = document.getElementById("lives-container");
        this.canvasElement = document.getElementById("canvas");
        this.lifeElements = [];
        this.screenHeight = null;
        this.screenWidth = null;
        this.intervalId = null;
        this.spawnTime = null;
        this.balloonSpeedMultiplier = 1;
        this.lives = null;
        this.lastCheckedInterval = null;
        this.lastcheckedScoreSpeed = null;
        this.state = "init";
        document.getElementById("score-label").style.transition = "";
        document.getElementById("score-label").style.transform = "translateY(-20px) translateY(-100%)";
        document.getElementById("lives-container").style.transition = "";
        document.getElementById("lives-container").style.transform = "translateY(-20px) translateY(-100%)";
        this.platform = new (0, $c39ed129cd641cb9$export$2dffd0b5373a4389)();
        (0, $22f5f922ddc3e706$export$9a23bd5abbd0d648)();
        this.loadConfig();
        this.setStyles();
        // Prepare game
        this.preload();
        this.timebonusLoop.bind(this);
    }
    playSound(soundKey, loop = false) {
        const config = this.config;
        if (config[soundKey + "Sound"]) this.platform.playSound(config.path + "/" + config[soundKey + "Sound"]);
    }
    drawLives() {
        this.platform.sendLives(this.lives);
    }
    /**
   * Initialzie the game
   */ initGame() {
        this.balloonId = 0;
        this.isPaused = true;
        this.score = 0;
        this.timer = 0;
        this.spawnTime = this.config.startSpawnTime;
        this.numberOfBalloons = 0;
        this.maxNumberOfBalloons = this.config.minNumberOfBalloons;
        this.balloonSpeedMultiplier = this.config.startSpeed;
        this.lives = this.config.lives;
        this.lastCheckedInterval = 0;
        this.lastcheckedScoreSpeed = 0;
        this.screenHeight = document.getElementById("canvas").clientHeight;
        this.screenWidth = document.getElementById("canvas").clientWidth;
        this.scoreElem = document.getElementById("score-count");
        this.scoreElem.style.fontFamily = this.config.scoreFont;
        this.scoreElem.style.color = this.config.scoreColor;
        this.scoreElem.style.fontSize = this.config.scoreSize + "px";
        this.drawLives();
        if (this.debug) console.log("__DEBUG MODE ENABLED__");
        else this.gameLog("__DEBUG MODE DISABLED__");
        this.platform.init(this, this.config, ()=>{
            this.state = "ready";
        });
        if (this.debug) top.window.addEventListener("keydown", (e)=>{
            if (e.code === "KeyP") this.pause();
        });
        (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(document, this.handleClick.bind(this), this.handleTap.bind(this));
        document.addEventListener("pointerup", ()=>{
            if (this.state !== "playing") this.startGame();
        });
        document.addEventListener("blur", (e)=>{
            this.pause();
        // Pause on blur?
        }, {
            passive: false
        });
        window.addEventListener("visibilitychange", (e)=>{
            if (document.visibilityState === "hidden") this.pause();
        }, {
            passive: false
        });
        // Safari
        document.addEventListener("pagehide", (event)=>{
            this.pause();
        }, {
            passive: false
        });
    }
    handleTap(e) {
        e.preventDefault();
        e.stopPropagation();
        this.handleClickTap(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }
    handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.handleClickTap(e.clientX, e.clientY);
    }
    handleClickTap(x, y) {
        if (this.isPaused) {
            this.resume();
            return;
        }
    }
    pause() {
        if (this.isPaused) return;
        if (this.state !== "playing") return;
        document.getElementById("overlay").style.display = "block";
        this.balloons.forEach((balloon)=>{
            balloon.pause(true);
        });
        this.bgElements.forEach((image)=>{
            image.pause(true);
        });
        this.isPaused = true;
    }
    resume() {
        document.getElementById("overlay").style.display = "none";
        this.balloons.forEach((balloon)=>{
            balloon.pause(false);
        });
        this.bgElements.forEach((image)=>{
            image.pause(false);
        });
        this.isPaused = false;
        window.setTimeout(()=>{
            this.updateGame();
        }, this.spawnTime);
    }
    loadConfig() {
        const urlParams = new URLSearchParams(window.location.search);
        this.config = $7b066675d1aa79fa$var$DefaultConfig;
        // Patch settings
        if (urlParams.get("s")) {
            const settings = atob(urlParams.get("s")).split("\n").filter((s)=>s.trim() !== "").map((s)=>{
                return {
                    name: s.split("=")[0].trim(),
                    value: s.split("=")[1].trim()
                };
            });
            this.gameLog(settings);
            settings.forEach((s)=>{
                if (!isNaN(+s.value)) this.config[s.name] = +s.value;
                else if (s.value === "true") this.config[s.name] = true;
                else if (s.value === "false") this.config[s.name] = false;
                else this.config[s.name] = s.value;
            });
        }
        const balloon4 = this.config.balloon4.split(",");
        const balloon2 = this.config.balloon2.split(",");
        const balloon3 = this.config.balloon3.split(",");
        const balloon1 = this.config.balloon1.split(",");
        //minspeed,maxspeed,hitscore,health,changescore,next,popscore
        this.config.balloonSettings = {
            balloon2: {
                minSpeed: +balloon2[0],
                maxSpeed: +balloon2[1],
                hitScore: +balloon2[2],
                popScore: +balloon2[4],
                next: balloon2[5],
                health: +balloon2[3]
            },
            balloon1: {
                minSpeed: +balloon1[0],
                maxSpeed: +balloon1[1],
                hitScore: +balloon1[2],
                popScore: +balloon1[4],
                next: balloon1[5],
                health: +balloon1[3]
            },
            balloon3: {
                minSpeed: +balloon3[0],
                maxSpeed: +balloon3[1],
                hitScore: +balloon3[2],
                popScore: +balloon3[4],
                next: balloon3[5],
                health: +balloon3[3]
            },
            balloon4: {
                minSpeed: +balloon4[0],
                maxSpeed: +balloon4[1],
                hitScore: +balloon4[2],
                popScore: +balloon4[4],
                next: balloon4[5],
                health: +balloon4[3]
            }
        };
        console.log("CONFIG", this.config);
    }
    preload() {
        this.platform.preloadSounds(this.config);
        const imageList = [
            this.config.balloon1Sprite,
            this.config.balloon2Sprite,
            this.config.balloon3Sprite,
            this.config.balloon4Sprite,
            this.config.planeSprite,
            this.config.explosionSprite,
            this.config.birdSprite,
            this.config.cloud1Sprite,
            this.config.cloud2Sprite,
            this.config.cloud3Sprite,
            this.config.lifeSprite,
            this.config.lifeLostSprite,
            this.config.splashSprite
        ];
        // const cache = this.debug ? '?' + Date.now() : '';
        let i = 0;
        imageList.forEach((imagename)=>{
            i++;
            const j = i;
            let img = new Image();
            img = new Image();
            img.src = this.config.path + imagename;
            img.onload = (e)=>this.checkImages(j, imagename);
            img.onerror = (e)=>this.checkImages(j, imagename);
            this.images.push(img);
        });
    }
    showSplash() {
        document.getElementById("splash").style.visibility = "visible";
        document.getElementById("score-label").style.transition = "";
        document.getElementById("score-label").style.transform = "translateY(-20px) translateY(-100%)";
        document.getElementById("lives-container").style.transition = "";
        document.getElementById("lives-container").style.transform = "translateY(-20px) translateY(-100%)";
    }
    checkImages(i, img) {
        this.imageLoadCount++;
        if (this.imageLoadCount === this.images.length) {
            console.log("ALL IMAGES LOADED ");
            this.initGame();
        }
    }
    setStyles() {
        const sheet = document.createElement("style");
        const path = this.config.path;
        sheet.innerHTML = `
            .plane {background-image: url("${path}${this.config.planeSprite}")}
            .life {background-image: url("${path}${this.config.lifeSprite}")}
            .life.lost {background-image: url("${path}${this.config.lifeLostSprite}")}
            .balloon.explosion {background-image: url("${path}${this.config.explosionSprite}"); animation: explosion ${this.config.explosionDuration}ms steps(${this.config.explosionFrames}); width: ${this.config.explosionWidth}px; height: ${this.config.explosionHeight}px}
            .balloon.balloon1 {background-image: url("${path}${this.config.balloon1Sprite}")}
            .balloon.balloon2 {background-image: url("${path}${this.config.balloon2Sprite}")}
            .balloon.balloon3 {background-image: url("${path}${this.config.balloon3Sprite}")}
            .balloon.balloon4 {background-image: url("${path}${this.config.balloon4Sprite}")}

            .cloud.type1 {background-image: url("${path}${this.config.cloud1Sprite}")}
            .cloud.type2 {background-image: url("${path}${this.config.cloud2Sprite}")}
            .cloud.type3 {background-image: url("${path}${this.config.cloud3Sprite}")}
            .bird {background-image: url("${path}${this.config.birdSprite}")}
            .overlay {background-color: ${this.config.overlayColor}}

            .splashcontent {
                background-image: url("${path}${this.config.splashSprite}");
                background-position: 50% ${this.config.splashY === "center" ? "50" : this.config.splashY}%;
                background-size: ${this.config.splashY === "center" ? "100% 100%" : this.config.splashScale * 100 + "%"}
            }


            @keyframes explosion {
                from { background-position: 0px; }
                to { background-position:-${this.config.explosionWidth * this.config.explosionFrames}px}
            }
        `;
        document.body.appendChild(sheet);
        const elmOverlay = document.getElementById("overlay");
        const elmOverlayContent = document.getElementById("overlayContent");
        elmOverlay.style.backgroundColor = this.config.overlayColor;
        elmOverlayContent.innerHTML = this.config.pauseMessage;
        elmOverlayContent.style.color = this.config.pauseMessageColor;
        elmOverlayContent.style.fontFamily = this.config.pauseMessageFont;
        elmOverlayContent.style.fontSize = this.config.pauseMessageSize + "px";
    }
    readyToPlay() {}
    play() {}
    startGame() {
        if (this.state !== "ready") return;
        document.getElementById("splash").style.visibility = "hidden";
        this.balloons = [];
        this.score = 0;
        this.lives = this.config.lives;
        this.platform.sendLives(this.lives);
        this.spawnTime = this.config.startSpawnTime;
        this.balloonSpeedMultiplier = this.config.startSpeed;
        this.lastCheckedInterval = 0;
        this.lastcheckedScoreSpeed = 0;
        this.state = "playing";
        this.scoreElem.innerHTML = 0;
        this.lifeElements.forEach((e)=>{
            e.classList.remove("lost");
        });
        this.startTime = performance.now();
        if (this.config.bonusPerMs > 0 || this.config.levelUpMethod) requestAnimationFrame(this.timebonusLoop.bind(this));
        this.gameLog(this.config.startSpawnTime);
        this.isPaused = false;
        this.updateGame();
        this.imageSpawner("cloud", 1, false, false);
        this.imageSpawner("cloud", 1, false, false);
        this.imageSpawner("cloud", 1, false, false);
        this.imageSpawner("plane", 1, false, false);
        this.imageSpawner("bird", 1, false, false);
        this.platform.gamestarted();
    // this.intervalId = window.setInterval(, );
    // this.pew.gamestarted();
    }
    timebonusLoop(delta) {
        delta = delta - this.startTime;
        if (this.state !== "playing") return;
        if (this.isPaused) {
            requestAnimationFrame(this.timebonusLoop.bind(this));
            return;
        }
        this.timer = delta;
        if (this.config.scoreType === "time" || this.config.scoreType === "timeandpoints") this.score = this.config.bonusPerMs * this.timer;
        this.updateScore(this.score, false);
        this.checkForLevelUp();
        requestAnimationFrame(this.timebonusLoop.bind(this));
    }
    updateScore(score, force) {
        this.score = score;
        this.checkForLevelUp();
        this.platform.sendScore(score, force);
    }
    /**
   * The update function is based on spawnTime
   */ updateGame() {
        if (this.debug) {
            document.getElementById("debugSpeed").innerHTML = this.config.levelUpMethod + ": increase=" + this.config.speedIncrease + ": current speed:" + this.balloonSpeedMultiplier?.toString() || "";
            document.getElementById("spanSpeed").innerHTML = this.spawnTime?.toString() || "";
        }
        if (this.isPaused) return;
        this.gameLog("update" + this.spawnTime);
        // first check if the player is already dead or not
        this.checkifGameOver();
        // then see if the player needs to get a multieplier or not
        // check if we need to increase spawnspeed
        // this.checkForLevelUp();
        if (this.state !== "playing") return;
        // create a random balloon
        if (this.numberOfBalloons < this.maxNumberOfBalloons) {
            this.numberOfBalloons += 1;
            setTimeout(()=>{
                let balloon = this.getRandomBalloon();
                // spawn the balloon on our 'canvas'
                balloon.spawnOnCanvas(this.balloonSpeedMultiplier, this.balloonId);
                this.gameLog("speed" + this.balloonSpeedMultiplier);
                this.balloons.push(balloon);
                this.balloonId++;
            }, this.spawnTime);
        }
        window.setTimeout(()=>{
            this.updateGame();
        }, this.spawnTime);
    }
    levelUp() {
        this.spawnTime = this.spawnTime - this.config.spawnIncrease;
        this.spawnTime = Math.max(this.spawnTime, this.config.minimumSpawnTime);
        this.balloonSpeedMultiplier += this.config.speedIncrease;
        this.maxNumberOfBalloons += this.config.balloonIncrease;
        this.maxNumberOfBalloons = Math.min(this.maxNumberOfBalloons, this.config.maxNumberOfBalloons);
    }
    /**
   * if the player has a score higher than 1000 the multiplier for the balloon speed wil increase by 0.5
   */ // checkForMultiplier(type: "") {
    //             if (this.score - this.lastCheckedScore > this.config.speedIncreaseInterval) {
    //                 this.lastCheckedScore = this.score;
    //                 this.balloonSpeedMultiplier += this.config.speedIncrease;
    //                 this.gameLog("Current balloonSpeed Multiplier increased to: " + this.balloonSpeedMultiplier);
    //             }
    //             break;
    //     }
    //     this.gameLog('speed' + this.balloonSpeedMultiplier);
    // }
    checkForLevelUp() {
        if (this.config.levelUpMethod === "none") return;
        if (this.config.levelUpMethod === "score") {
            if (this.score - this.lastCheckedInterval > this.config.levelUpInterval) {
                this.lastCheckedInterval = this.timer;
                this.levelUp();
            }
        }
        if (this.config.levelUpMethod === "time") {
            if (this.timer - this.lastCheckedInterval > this.config.levelUpInterval) {
                this.lastCheckedInterval = this.timer;
                this.levelUp();
            }
        }
    }
    /**
   * Checks if the player is game over or not.
   */ checkifGameOver() {
        if (this.state === "gameover") return;
        this.gameLog("Check gameover");
        if (this.lives <= 0) this.gameover();
    }
    gameover() {
        clearInterval(this.timeBonusLoop);
        this.platform.gameover(Math.floor(this.score));
        this.state = "gameover";
    // this.balloons.forEach(balloon => {
    //     balloon.destroy();
    // })
    }
    restart() {
        this.showSplash();
        // Destroy old balloons
        this.balloons.forEach((balloon)=>{
            balloon.destroy();
        });
        this.scoreElem.innerHTML = 0;
        this.lifeElements.forEach((e)=>{
            e.classList.remove("lost");
        });
        this.initGame();
        this.state = "ready";
        this.platform.ready();
        this.bgElements.forEach((bg)=>{
            bg.destroy();
        });
        this.bgElements = [];
    }
    /**
   * Get a random baloon to spawn
   */ getRandomBalloon() {
        const random = Math.random();
        const rand = Math.floor(random * this.config.balloonTypes);
        this.playSound("spawn");
        switch(rand){
            case 0:
                return new (0, $3fb20517fc32462b$export$3016537a1ffc38d5)(this, "balloon1", this.config.balloonSettings.balloon1);
            case 1:
                return new (0, $3fb20517fc32462b$export$3016537a1ffc38d5)(this, "balloon2", this.config.balloonSettings.balloon2);
            case 2:
                return new (0, $3fb20517fc32462b$export$3016537a1ffc38d5)(this, "balloon3", this.config.balloonSettings.balloon3);
            case 3:
                return new (0, $3fb20517fc32462b$export$3016537a1ffc38d5)(this, "balloon4", this.config.balloonSettings.balloon4);
            default:
                return new (0, $3fb20517fc32462b$export$3016537a1ffc38d5)(this, "green", this.config.balloonSettings.balloon1);
        }
    }
    /**
   * Removes life from player
   */ removeLife() {
        if (this.lives > 0) {
            this.playSound("loseLife");
            this.lives--;
            this.drawLives();
            this.checkifGameOver();
        }
    }
    /**
   * Sets the spawntime for mages on the background, bird plane cloud
   * @param {string} type
   * @param {int} amount
   * @param {bool} directSpawn
   */ imageSpawner(type, amount, directSpawn, diffentSpawnPos) {
        var spawnTime = 0;
        var spawnTimeMin = this.config[type + "SpawnTimeMin"];
        var spawnTimeMax = this.config[type + "SpawnTimeMax"];
        if (!directSpawn) spawnTime = Math.floor(Math.random() * (spawnTimeMax - spawnTimeMin)) + spawnTimeMin;
        for(let i = 0; i < amount; i++)this.setImageTimout(type, amount, directSpawn, spawnTime, i, diffentSpawnPos);
    }
    /**
   * Spawns the actual images
   * @param {string} type
   * @param {int} amount
   * @param {boolean} directSpawn
   * @param {int} spawnTime
   * @param {int} i
   */ setImageTimout(type, amount, directSpawn, spawnTime, i, diffentSpawnPos) {
        var game = this;
        // return;
        setTimeout(()=>{
            if (this.state !== "playing") return;
            var spawnthis = null;
            switch(type){
                case "cloud":
                    if (amount == 1) i = Math.floor(Math.random() * Math.floor(3));
                    spawnthis = new (0, $cbffd09070f7415f$export$3d0b85b7d4419b92)(game, type, game.generateRandomNumber(0.3, 1), diffentSpawnPos, i);
                    break;
                case "bird":
                    spawnthis = new (0, $cbffd09070f7415f$export$3d0b85b7d4419b92)(game, type, 1, diffentSpawnPos);
                    break;
                case "plane":
                    spawnthis = new (0, $cbffd09070f7415f$export$3d0b85b7d4419b92)(game, type, 4, diffentSpawnPos);
                    break;
            }
            spawnthis.spawnOnCanvas();
            this.bgElements.push(spawnthis);
        }, spawnTime);
    }
    generateRandomNumber(min, max) {
        return Math.random() * (max - min) + min;
    }
    endGame() {}
    gameLog(text) {
        if (this.debug) console.log(text);
    }
}


document.addEventListener("DOMContentLoaded", (e)=>{
    // eslint-disable-next-line no-new
    new (0, $7b066675d1aa79fa$export$35806d2c657a1231)();
});
function $ad2bcec7a0192558$export$4e8d255ef2ada17e(config) {
    let string = "";
    for (const [key, value] of Object.entries(config))string += key + "=" + value + "\n";
    console.log(string);
}


//# sourceMappingURL=index.b94be7b3.js.map
